import { Button } from '@/components/ui/button'
import { useSocialText } from '@/social/use-social-text'
import { Bell, BellOff, Loader2 } from 'lucide-react'

export function ConversationNotificationMuteButton({
  canMuteNotifications,
  isAdministrator,
  notificationsMuted,
  pending,
  onToggle,
}: {
  canMuteNotifications: boolean
  isAdministrator: boolean
  notificationsMuted: boolean
  pending: boolean
  onToggle: (muted: boolean) => void
}) {
  const text = useSocialText()

  if (!canMuteNotifications || isAdministrator)
    return null

  const label = notificationsMuted
    ? text('social.actions.unmuteNotifications', 'Unmute notifications')
    : text('social.actions.muteNotifications', 'Mute notifications')

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="size-8"
      disabled={pending}
      aria-busy={pending}
      aria-pressed={notificationsMuted}
      onClick={() => onToggle(!notificationsMuted)}
      title={label}
      data-testid="social-conversation-notification-mute"
    >
      {pending ? (
        <Loader2 className="size-4 animate-spin" />
      ) : notificationsMuted ? (
        <BellOff className="size-4" />
      ) : (
        <Bell className="size-4" />
      )}
      <span className="sr-only">{label}</span>
    </Button>
  )
}
